import {
  Button,
  Card,
  Chip,
  Collapse,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { blueGrey } from "@material-ui/core/colors";
import { Clear, Done, FilterList, Inbox } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import MomentUtils from "@date-io/moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import { withAuthorization } from "../Session";
import CountUp from "react-countup";
import TestTable from "./TestTable";

const INITIAL_STATISTICS = {
  totalSend: 0,
  unknownUsers: 0,
  totalResponses: 0,
  completed: 0,
  partialyCompleted: 0,
  noCompleted: 0,
};

const ComunicationTestPage = (props) => {
  const classes = useStyles();
  const { firebase } = props;

  const [groupSelectorOpen, setGroupSelectorOpen] = useState(false);
  const [programList, setProgramList] = useState({});
  const [selected, setSelected] = useState([]);
  const [filterStartDate, setFilterStartDate] = useState(moment());
  const [filterEndDate, setFilterEndDate] = useState(moment());
  const [statistics, setStatistics] = useState(INITIAL_STATISTICS);
  const [deviceData, setDeviceData] = useState([]);
  const [isLoadingData, setisLoadingData] = useState(false);
  const [alertUsers, setAlertUsers] = useState({});
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState([]);
  const [filteredTotalUsers, setfilteredTotalUsers] = useState([]);

  const handleGroupSelector = () => {
    setGroupSelectorOpen(!groupSelectorOpen);
  };

  useEffect(() => {
    firebase
      .users()
      .once("value")
      .then((snap) => {
        const users = snap.val();
        setTotalUsers(
          Object.keys(users).map((u) => ({
            uid: u,
            groups: Object.keys(users[u].sgpfc.programs)
              .map((p) => users[u]?.sgpfc.programs[p].groups)
              .join()
              .split(","),
          }))
        );
        let usersWithAlert = {};
        Object.keys(users)
          .filter((k) => users[k]?.sgpfc.hasOwnProperty("deviceTokens"))
          .forEach((u) => (usersWithAlert[u] = users[u]));
        setAlertUsers(usersWithAlert);
      });

    firebase
      .getAvailablePrograms()
      .once("value")
      .then((snap) => {
        const prog = snap.val();
        let progList = {};
        Object.keys(prog).forEach((k) => {
          progList[k] = { name: prog[k].name, g: [] };
          Object.keys(prog[k].groups).forEach((e) => {
            progList[k].g.push({ id: e, name: prog[k].groups[e].name });
          });
        });
        setProgramList(progList);
      });
  }, []);

  const handleProgramSelection = (program) => {
    //console.log(program);
    let programWithGroups = programList[program].g.map((e) => e.id).concat([program]);
    //console.log(programWithGroups);
    if (selected.includes(program)) {
      setSelected(selected.filter((e) => !programWithGroups.includes(e) && e));
    } else {
      setSelected([...new Set(selected.concat(programWithGroups))]);
    }
  };

  const handleGroupSelection = (group, prog) => {
    //console.log(group, prog);
    if (selected.includes(group)) {
      setSelected(selected.filter((e) => e !== group && e !== prog && e));
    } else {
      var aux = selected;
      aux.push(group);
      programList[prog].g.every((v) => selected.includes(v.id)) && aux.push(prog);
      setSelected(aux.map((v) => v));
    }
  };

  useEffect(() => {
    if (selected.length === 0) {
      setFilteredUsers(Object.keys(alertUsers));
      setfilteredTotalUsers(totalUsers);
    } else {
      // filtra a los usuarios que están en alguno de los grupos seleccionados
      setfilteredTotalUsers(totalUsers.filter((user) => user.groups.filter((g) => selected.includes(g)).length > 0));
      setFilteredUsers(
        Object.keys(alertUsers).filter(
          (u) =>
            Object.keys(alertUsers[u]?.sgpfc?.programs)
              .map((p) => alertUsers[u]?.sgpfc?.programs[p]?.groups)
              .join()
              .split(",")
              .filter((f1) => selected.includes(f1)).length > 0
        )
      );
    }
  }, [selected, alertUsers]);

  const handleFilter = () => {
    setisLoadingData(true);
    var filteredKeys = [];
    firebase.getComunicationsSetUps().then((snap) => {
      const setUps = snap.val();
      var total = 0;
      var unknows = 0;
      Object.keys(setUps).forEach((k) => {
        //TODO Filtrar los setUps en función de los filtros

        if (
          moment(setUps[k].time).isSameOrAfter(filterStartDate) &&
          (setUps[k]?.groupconfig.map((c) => c.group).filter((e) => selected.includes(e)).length > 0 || selected.length === 0)
        ) {
          filteredKeys.push(k);
          total += setUps[k].totalSentDevices;
          unknows += setUps[k].totalUnknownUsers;
        }
      });
      getAllTestData({ dataAnalysis: { state: { 0: 0, 1: 0, 2: 0 } }, devices: [] }, filteredKeys, setUps).then((data) => {
        const dataAnalysis = data.dataAnalysis;
        setDeviceData(data.devices);
        setisLoadingData(false);
        setStatistics({
          ...statistics,
          totalResponses: dataAnalysis?.state[1] + dataAnalysis?.state[2], // / filteredKeys.length,
          completed: dataAnalysis?.state[1], // / filteredKeys.length, / Object.keys(setUps).length,
          partialyCompleted: dataAnalysis?.state[2], // / filteredKeys.length, / Object.keys(setUps).length,
          noCompleted: dataAnalysis?.state[0], // / filteredKeys.length, / Object.keys(setUps).length,
          unknownUsers: unknows, // / filteredKeys.length, / Object.keys(setUps).length,
          totalSend: total, // / filteredKeys.length,/ Object.keys(setUps).length,
        });
      });
    });
  };

  const getAllTestData = (data, remainingTest, setUps) => {
    return new Promise((resolve, reject) => {
      if (!remainingTest.length) {
        resolve(data);
      } else {
        var testKey = remainingTest.pop();
        firebase
          .getComunictionTestData(testKey)
          .get()
          .then((snap) => {
            let responses = snap.val();
            if (!!responses) {
              // data[testKey] = responses;
              data.devices = data.devices.concat(
                Object.keys(responses)
                  .map((k, i) => ({
                    ...responses[k],
                    token: k,
                    id: k,
                    enableHighAccuracy: setUps[testKey].enableHighAccuracy,
                    sendTime: setUps[testKey].time,
                    maximumAge: setUps[testKey].maximumAge,
                    GSPTimeOut: [setUps[testKey].positionTimeOut],
                    i: remainingTest.length,
                  }))
                  //.filter((k) => k.state !== 0)
                  .reverse()
              );
              Object.keys(responses).forEach((k) => (data.dataAnalysis.state[responses[k].state] += 1));
            }
            resolve(getAllTestData(data, remainingTest, setUps));
          })
          .catch((err) => reject(err));
      }
    });
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Grid container className={classes.mainContainer} justify="center">
        <Grid item xs={12} lg={10} container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h4" style={{ color: blueGrey[50] }}>
              Análisis de comunicaciones
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" style={{ color: blueGrey[100] }}>
              Filtro de las pruebas
            </Typography>
            <Card elevation={2} className={classes.filterCard}>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={2} container alignItems="center">
                  <IconButton onClick={handleGroupSelector}>
                    <FilterList />
                  </IconButton>
                  <Typography variant="body1">Filtro de programas</Typography>
                </Grid>
                <Grid item xs={12} lg={2} container alignItems="center">
                  <Typography variant="body1">Usuarios activos:</Typography>
                  <Typography variant="h6">{` ${filteredUsers.length} de ${filteredTotalUsers.length}`}</Typography>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <DatePicker
                    variant="inline"
                    fullWidth
                    inputVariant="outlined"
                    label="Fecha inicio"
                    format="DD/MM/YYYY"
                    value={filterStartDate}
                    onChange={(e) => setFilterStartDate(e)}
                  />
                </Grid>

                <Grid item xs={12} lg={3}>
                  <DatePicker
                    variant="inline"
                    fullWidth
                    inputVariant="outlined"
                    label="Fecha fin"
                    format="DD/MM/YYYY"
                    value={filterEndDate}
                    onChange={(e) => setFilterEndDate(e)}
                  />
                </Grid>
                <Grid item container xs={12} lg={2} justify="flex-end">
                  <Button variant="contained" disabled={isLoadingData} fullWidth color="primary" style={{ textTransform: "none", color: "white" }} onClick={handleFilter}>
                    Buscar resultados
                    {isLoadingData && (
                      <CircularProgress
                        size={24}
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          marginTop: -12,
                          marginLeft: -12,
                        }}
                      />
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Card>
            <Grid item xs={12} container spacing={1} style={{ marginTop: 9 }}>
              {selected.length === 0 && (
                <Grid item>
                  <Chip label={"Todos los grupos"} color="primary" />
                </Grid>
              )}
              {selected.map((s) => (
                <Grid item>
                  <Chip label={s} onDelete={() => handleGroupSelection(s)} />
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item xs={12} container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Estadisticas (medias de las pruebas)</Typography>
            </Grid>
            <AnalyticCardContent value={statistics.totalSend} property={"Total enviado"} />
            <AnalyticCardContent value={statistics.unknownUsers} property={"Usuarios sin Alert"} />
            <AnalyticCardContent value={statistics.totalResponses} property={"Respuestas totales"} />
            <AnalyticCardContent value={statistics.completed} property={"Completos"} />
            <AnalyticCardContent value={statistics.partialyCompleted} property={"Parciales"} />
            <AnalyticCardContent value={statistics.noCompleted} property={"Sin respuesta"} />
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Resultados</Typography>
            </Grid>
            <TestTable rows={deviceData} />
          </Grid>
        </Grid>

        <Dialog onClose={handleGroupSelector} aria-labelledby="simple-dialog-title" open={groupSelectorOpen}>
          <DialogTitle id="simple-dialog-title">Selecciona los grupos</DialogTitle>
          <List component="div" dense>
            {Object.keys(programList).map((p) => {
              return (
                <>
                  <ListItem key={p} button onClick={() => handleProgramSelection(p)}>
                    <ListItemIcon>{selected.includes(p) ? <Done /> : <Clear />}</ListItemIcon>
                    <ListItemText primary={`${programList[p].name}`} />
                  </ListItem>
                  <Collapse in>
                    <List component="div" dense disablePadding>
                      {programList[p].g.map((g) => (
                        <ListItem key={g.id} button className={classes.nested} onClick={() => handleGroupSelection(g.id, p)}>
                          <ListItemIcon>{selected.includes(g.id) ? <Done /> : <Clear />}</ListItemIcon>
                          <ListItemText primary={`${g.name}`} style={{ textDecoration: "bold" }} />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </>
              );
            })}
          </List>
          <DialogActions>
            <Button onClick={handleGroupSelector}>Aplicar</Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

const AnalyticCardContent = ({ value, property }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} sm={4} lg={2}>
      <Card className={classes.staticCard}>
        <Grid container alignItems="center" direction="column">
          <Grid item>
            <Typography variant="h3">
              <CountUp end={value} duration={1} easingFn={(0.5, 1, 0.89, 1)} />
            </Typography>
          </Grid>
          <Grid item>
            <Typography>{property}</Typography>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};

const condition = (authUser) => authUser.sgpfc.rol == "admin";

export default withAuthorization(condition)(ComunicationTestPage);

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    background: `linear-gradient( #9933CC 0 232px, transparent 232px 100%)`,
    // minHeight: "100vh",
    paddingTop: 36,
  },
  filterCard: {
    borderRadius: 9,
    padding: theme.spacing(4),
    marginTop: theme.spacing(2),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  staticCard: {
    padding: theme.spacing(2),
  },
}));
